import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';

type ApiEnvelope<T> = { data: T; message?: string; statusCode: number };

export type StockPlanReportViewMode = 'ADMIN' | 'PARTNER';

export interface StockPlanReportEmailRequest {
  recipientEmails: string[];
  viewMode: StockPlanReportViewMode;
  partnerId?: string;
  subject?: string;
  note?: string;
}

export interface StockPlanReportEmailResult {
  emailsSent: number;
}

const BASE = `${LEAD_API_PREFIX}/capitals/stock-plans`;

export async function sendStockPlanReportEmail(
  planId: string,
  body: StockPlanReportEmailRequest
): Promise<StockPlanReportEmailResult> {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${BASE}/${encodeURIComponent(planId)}/report/email`,
    data: body,
  });
  return (response.data as ApiEnvelope<StockPlanReportEmailResult>).data;
}
